import React from 'react'
import { imageAddress, priceStandardView, translate } from '../../utils/useful'
import TLink from '../TLink'

class AppletBox extends React.Component {

    state = {
        open: false
    }



    render() {

        let link = '/applet/' + this.props.data?.aTarget?._id
        return (
            <div className="w-100 service-box h-100 d-flex flex-column">
                <div className="w-100 cover-img-container m-0 p-0 flexcc">
                    <TLink className="m-0 px-3 pt-3 pb-2 w-100 h-100 flexcc " to={link}>
                        <img className="cover-img m-0 p-0" src={imageAddress(this.props.data?.aTarget?.image)} alt="" style={{width:80,height:80,objectFit:'cover',borderRadius:80}} />
                    </TLink>
                </div>


                <div className="mx-3   pb-3 service-box-content text-center" style={{flex:1}}>
                    <TLink to={link}>
                        <h3 className="font-bold text-semibig m-0">{this.props.data?.aTarget?.name}</h3>
                    </TLink>
                    {/* <TLink to={link}><p className="service-box-desc text-smaller">{this.props.data?.aTarget?.type}</p></TLink> */}

                    {this.props.data?.aTarget?.description && (
                        <TLink to={link}><p className="mt-1" style={{ fontSize: 13 }}>{this.props.data?.aTarget?.description}</p></TLink>
                    )}

                    {/* <p className=" text-uppercase mt-1 text-bold mb-1" style={{fontSize:12}}>Characteristics</p> */}
                    
                    {/* <div className="flexc mt-2">
                        <div className="mrd-2" style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '5px 10px' }}>
                            <p className="  text-bold text-capitalize" style={{ fontSize: 11, color: '#567' }}>Type: {this.props.data?.aTarget?.type}</p>
                        </div>
                    </div> */}

                    {/* <div className="flexc mt-1 mb-1" style={{ flexWrap: 'wrap' }}>
                        {this.props.data?.structure?.map((prop, index) => {
                            if (prop.available) {
                                return (
                                    <div key={index} className="mrd-2" style={{ backgroundColor: '#f2f6f8', borderRadius: 4, padding: '5px 10px' }}>
                                        <p className="  text-bold text-capitalize" style={{ fontSize: 11, color: '#567' }}>{prop.label}</p>
                                    </div>
                                )
                            }
                        })}
                    </div> */}
                

                </div>
{/* 
                <div className="flexcb service-box-actions  mx-3 pb-3 pt-3">
                    <div className="flexc">
                    <TLink to={link} className="py-1 px-3 preview-but">
                        <p className=" text-bold text-capitalize">{translate("useful.preview")}</p>
                    </TLink>

                    <TLink to={'/applet/'+this.props.data?.aTarget?._id+"/edit"}  className="py-1 px-3 preview-but mld-1">
                        <p className=" text-bold text-capitalize">{translate("useful.edit")}</p>
                    </TLink>
                    </div>

                    <div>
                        <p className="text-normal text-bold service-box-price">${priceStandardView(this.props.data?.aTarget?.price)}</p>

                    </div>
                </div> */}

            </div>
        )
    }
}

export default AppletBox
